import { render } from "./FormSelect.vue?vue&type=template&id=3d138c53&ts=true"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__